const UserId = (state) => state.UserId;
const User = (state) => state.User;
const StatisticInfo = (state) => state.StatisticInfo;
const UserProfile = (state) => state.UserProfile;
const Resources = (state) => state.Resources;
export default { UserId, User, StatisticInfo, UserProfile, Resources };
